const LinkIcon = ({ size = 24, color = 'white' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3334 12.8335C10.6913 13.3119 11.1478 13.7078 11.6722 13.9942C12.1965 14.2807 12.7763 14.4511 13.3723 14.4937C13.9682 14.5364 14.5664 14.4504 15.1262 14.2416C15.686 14.0328 16.1943 13.706 16.6167 13.2835L19.1167 10.7835C19.8757 9.99762 20.2957 8.94511 20.2862 7.85263C20.2767 6.76014 19.8385 5.71509 19.066 4.94256C18.2934 4.17002 17.2484 3.73182 16.1559 3.72233C15.0634 3.71283 14.0109 4.13281 13.225 4.8918L11.7917 6.3168M13.6667 11.1668C13.3088 10.6884 12.8522 10.2925 12.3279 10.006C11.8036 9.71955 11.2238 9.5492 10.6278 9.50652C10.0319 9.46384 9.43372 9.54983 8.87392 9.75865C8.31412 9.96747 7.80578 10.2942 7.38338 10.7168L4.88338 13.2168C4.12439 14.0026 3.70441 15.0552 3.7139 16.1476C3.7234 17.2401 4.1616 18.2852 4.93413 19.0577C5.70667 19.8302 6.75172 20.2684 7.84421 20.2779C8.93669 20.2874 9.9892 19.8675 10.775 19.1085L12.2 17.6835"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LinkIcon;
